import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

import { BatchesSettingsView } from "./BatchesSettingsView";

type Props = {
  viewTitle: ViewNameTranslation;
};

export function BatchesSettingsPage({ viewTitle }: Props) {
  useNavbar({ viewTitle });
  return <BatchesSettingsView />;
}
